var _path, _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7737 28.2536L26.1522 28.7198C22.5072 31.4535 17.4954 31.4535 13.8504 28.7197L13.2289 28.2536C9.09871 25.156 6.66797 20.2945 6.66797 15.1317V10.7669C6.66797 8.50216 8.50387 6.66626 10.7686 6.66626H29.234C31.4987 6.66626 33.3346 8.50216 33.3346 10.7669V15.1317C33.3346 20.2945 30.9039 25.156 26.7737 28.2536Z",
    stroke: "url(#paint0_linear_623_3459)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9987,
    cy: 16.6667,
    r: 1.66667,
    fill: "url(#paint1_linear_623_3459)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9987,
    cy: 16.6667,
    r: 1.66667,
    fill: "url(#paint2_linear_623_3459)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9987,
    cy: 16.6667,
    r: 1.66667,
    fill: "url(#paint3_linear_623_3459)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3459",
    x1: 6.66797,
    y1: 19.9996,
    x2: 33.3346,
    y2: 19.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_3459",
    x1: 18.332,
    y1: 16.6667,
    x2: 21.6654,
    y2: 16.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_3459",
    x1: 13.332,
    y1: 16.6667,
    x2: 16.6654,
    y2: 16.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_3459",
    x1: 23.332,
    y1: 16.6667,
    x2: 26.6654,
    y2: 16.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCampaign);
export default __webpack_public_path__ + "static/media/message_campaign.4e9bef55eaf6d83c4740dd27bcd36bce.svg";
export { ForwardRef as ReactComponent };